import { ApiRoutes } from '@/shared/constant/api';
import { api } from '@/shared/helpers/axios';

import { IRelationRequestPayload } from '../types/relation.types';

export const relationApi = {
	addToFavourite: (payload: IRelationRequestPayload) => api.post(ApiRoutes.Relation, payload),
	removeFromFavourite: (placeId: IRelationRequestPayload['booking_object_id']) =>
		api.delete(`${ApiRoutes.Relation}/${placeId}`),
};
